"use strict";
import "../app/csrf_xhr";
import $ from "jquery";
window.$ = $;
window.jQuery = $;
import "jquery-ui";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/widgets/dialog";
import "jquery-ui/ui/widgets/tabs";
import "jquery-ui/ui/widgets/sortable";
import "jquery-ujs";
import "@activeadmin/activeadmin";
import "active_admin_datetimepicker";
$(document).ready(function() {
  $("#tabs").clone().insertAfter("#footer");
});
